export default "__VITE_ASSET__BCcNlii4__"